export default {
    information: {
        subtitle:
            "Let's get you set up to create invoices. Enter your business' contact information to the right.",
        title: 'Welcome to MakeLeaps!',
    },
    pageForm: {
        addFax: 'Add a fax number',
        businessAdditionalText:
            'You can use this email as the default Reply-To address for outgoing emails from MakeLeaps.',
        phoneAdditionalText:
            "Please enter your company's main business phone number.",
        subtitle:
            'To create your invoice, we need some additional information. You can change this anytime later.',
        title: 'Business Contact',
    },
};
